import React from "react";

// Dropdown
import { DropDown as DropDownContext } from "core/DropDown/index.js";

// components
import LinkDropDown from "core/SiteHeader/components/LinkDropDown";

// data
import { primaryMenu } from "data/links";
const { about, blog, podcast, customerSupport, lingo } = primaryMenu.tnp.links;

// component
const DropDown = () => {
    return (
        <DropDownContext>
            <LinkDropDown link={about} />
            <LinkDropDown link={blog} />
            <LinkDropDown link={podcast} />
            <LinkDropDown link={lingo} />
            <LinkDropDown link={customerSupport} />
        </DropDownContext>
    );
};

export default DropDown;
